import { lazy } from "react";
import { connect } from "react-redux";
import {
  loading,
  data,
  pagination,
} from "../../../store/administration/selectors/concept_types";

const ConceptTypes = lazy(() => import("./ConceptTypes"));

const mapStateToProps = (state) => ({
  isLoading: loading(state),
  conceptTypes: data(state),
  pagination: pagination(state),
});

export default connect(mapStateToProps)(ConceptTypes);
